import React, { useState } from "react";
import { Link } from "react-router-dom";
import { errorToast, successToast } from "../Common/showtoast";
import ApiRequest from "../Common/restservice";

function Footer() {
  const [email, setEmail] = useState("");
  const Subscribe = async () => {
    if (!email) {
      return errorToast("Enter valid email");
    }
    let res = await ApiRequest(
      "newsletters_common.asp",
      "POST",
      JSON.stringify({ email })
    );
    if (res.status === "error") {
      errorToast(res.message);
      return;
    }
    setEmail("");
    successToast(res.message);
  };
  return (
    <section className="main-footer">
      <footer className="bg-white">
        <div className="footer-main footer-main1">
          <div className="container">
            <div className="row">
              <div className="col-lg-4 col-md-12">
                <h6>Company</h6>
                <hr className="deep-purple text-primary accent-2 mb-4 mt-0 d-inline-block mx-auto" />
                <ul className="list-unstyled mb-0">
                  <li>
                    <Link to={"/about"}>About Us</Link>
                  </li>
                  <li>
                    <Link to={"/terms"}>Terms and Conditions</Link>
                  </li>
                  <li>
                    <Link to={"/privacypolicy"}>Privacy Policy</Link>
                  </li>
                  <li>
                    <a href="https://www.hmmi.net/" target="_blank">Marketing Training</a>
                  </li>
                </ul>
              </div>
              <div className="col-lg-4 col-md-12">
                <h6>For Customers</h6>
                <hr className="deep-purple  accent-2 mb-4 mt-0 d-inline-block mx-auto" />

                <ul className="list-unstyled mb-0">
                  <li>
                    <Link to={"/contact"}>Contact Us</Link>
                  </li>
                  <li>
                    <Link to={"/pricing"}>Subscription Plan</Link>
                  </li>
                  <li>
                    <Link to={"/news"}>Blogs</Link>
                  </li>
                </ul>
              </div>
              <div className="col-lg-4 col-md-12">
                <h6>Contact</h6>
                <hr className="deep-purple  text-primary accent-2 mb-4 mt-0 d-inline-block mx-auto" />
                <ul className="list-unstyled mb-0">
                  <li>
                    <a href="#">
                      <i className="fa fa-home me-3 text-primary"></i> No:29, <br />  Dharmaraja Koil St, Periyapet,<br /> Saidapet, Chennai, Tamil Nadu 600015
                      <br />
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <i className="fa fa-envelope me-3 text-primary"></i>
                      info@happiedealz.com
                    </a>
                  </li>
                  {/* <li>
                    <a href="#">
                      <i className="fa fa-phone me-3 text-primary"></i> +91 9884809607
                    </a>
                  </li> */}
                </ul>
                <ul className="list-unstyled list-inline mt-3">
                  <li className="list-inline-item">
                    <a href="https://www.facebook.com/happiedealz" target="_blank" className="btn-floating btn-sm rgba-white-slight mx-1 waves-effect waves-light">
                      <i className="fa fa-facebook bg-facebook"></i>
                    </a>
                  </li>
                  <li className="list-inline-item">
                    <a href="https://www.instagram.com/happiedealz" target="_blank" className="btn-floating btn-sm rgba-white-slight mx-1 waves-effect waves-light">
                      <i className="fa fa-instagram bg-pink"></i>
                    </a>
                  </li>
                  {/* <li className="list-inline-item">
                    <a className="btn-floating btn-sm rgba-white-slight mx-1 waves-effect waves-light">
                      <i className="fa fa-whatsapp bg-success"></i>
                    </a>
                  </li>
                  <li className="list-inline-item">
                    <a className="btn-floating btn-sm rgba-white-slight mx-1 waves-effect waves-light">
                      <i className="fa fa-telegram bg-info"></i>
                    </a>
                  </li> */}
                  <li className="list-inline-item">
                    <a href="https://linkedin.com/company/happie-dealz/about/" target="_blank" className="btn-floating btn-sm rgba-white-slight mx-1 waves-effect waves-light">
                      <i className="fa fa-linkedin bg-linkedin"></i>
                    </a>
                  </li>
                </ul>
              </div>
              {/* <div className="col-lg-4 col-md-12">
                <h6>Newsletter</h6>
                <hr className="deep-purple  text-primary accent-2 mb-4 mt-0 d-inline-block mx-auto" />
                <div className="clearfix"></div>
                <div className="input-group w-70">
                  <input
                    type="text"
                    className="form-control br-ts-3  br-bs-3 "
                    placeholder="Email"
                    onChange={(e) => setEmail(e.target.value)}
                    value={email}
                  />
                  <div className=" ">
                    <button
                      type="button"
                      className="btn btn-primary br-ts-0  br-bs-0"
                      onClick={Subscribe}
                    >
                      Subscribe
                    </button>
                  </div>
                </div>
              </div> */}
            </div>
          </div>
        </div>
        <div className="bg-white p-0">
          <div className="container">
            <div className="row d-flex">
              <div className="col-lg-12 col-sm-12 mt-3 mb-3 text-center ">
                Copyright © 2024
                <Link to={"/"} className="fs-14 text-primary">
                  &nbsp; HappieDealz &nbsp;
                </Link>
                All rights reserved.
              </div>
            </div>
          </div>
        </div>
      </footer>
    </section>
  );
}

export default Footer;
